export default {"src":"/_next/static/media/logo-googleplay.648d1c0e.svg","height":274,"width":923};